
import PropTypes from 'prop-types'
import React from 'react'
import './index.css'
import Space from 'ui/Space'
import BulletList from 'ui/BulletList'
import { FlexGrid, FlexItem } from 'ui/flexgrid'
import Button from 'ui/Button'
import Block from 'ui/Block'
import Link from 'ui/Link'
import CheckboxTile from 'ui/CheckboxTile'

const WarehouseMetadataSelector = props => (
  <FlexGrid justifyContent='center'>
    <FlexItem width='700' spaceRight={24}>
      <div className='WarehouseMetadataSelector'>
        <Block spaceTop={56} spaceLeft={56} spaceRight={56} spaceBottom={28}>
          <header>
            <h2 className='WarehouseMetadataSelector-heading'>Select Database Type</h2>
            <Space value={8} />
            <p>Pro tip: You’ll need to have your login credentials and admin access to your database.</p>
          </header>
          <Space value='28' />
          <div className='WarehouseMetadataSelector-items'>
            <FlexGrid>
              {props.list.map(metadata =>
                <FlexItem width='200' key={metadata.id}>
                  <Block spaceLeft={7} spaceRight={7}>
                    <CheckboxTile
                      logo={metadata.logos.default}
                      title={metadata.name}
                      description={metadata.description}
                      value={metadata.id}
                      isRadio
                      isChecked={props.databaseId === metadata.id}
                      onChange={() => props.onSelect(metadata.id)}
                      name='warehouse_metadata' />
                  </Block>
                </FlexItem>
              )}
            </FlexGrid>
          </div>
          <Space value={28} />
          <Link href='https://segment.com/docs/faqs/warehouses/redshift-v-postgres-v-bigquery/' rel='external' target='_blank'>
            Compare the different types of Warehouses
          </Link>
        </Block>
        <div className='WarehouseMetadataSelector-submit'>
          <FlexGrid justifyContent='flex-end'>
            <FlexItem>
              <Button onClick={props.onNext} disabled={!props.databaseId}>
                Select Database
              </Button>
            </FlexItem>
          </FlexGrid>
        </div>
      </div>
    </FlexItem>
    <FlexItem width='250'>
      <h4>The Easy Way</h4>
      <Space value={4} />
      <p>If you upgrade to the <Link href='https://segment.com/pricing' target='_blank'>Business plan</Link> we’ll help get you setup, plus you’ll get access to more features:</p>
      <Space value='14' />
      <BulletList>
        <li>Alerting</li>
        <li>Custom Sync Schedule</li>
        <li>Selective Sync</li>
        <li>Vaccuming</li>
      </BulletList>
      <Space value='14' />
      <Link href='https://segment.com/contact/sales' rel='external' target='_blank'>
        Contact us
      </Link>
    </FlexItem>
  </FlexGrid>
)

WarehouseMetadataSelector.displayName = 'WarehouseMetadataSelector'

WarehouseMetadataSelector.propTypes = {
  databaseId: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  onNext: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
}
export default WarehouseMetadataSelector



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/components/warehouse-metadata-selector/index.js